import gql from 'graphql-tag';

export default gql`
  fragment clientAllowedIpFragment on ClientAllowedIp {
    id
    clientId
    ip
  }
`;
